export const emptyFocused = "zMb";
export const emptyOther = "AMb";
export const emptyFolder = "BMb";
export default {emptyFocused,emptyOther,emptyFolder};